import React from "react";
import WishlistCollection from "./WishlistCollection";
import SharedCartsCollection from "./SharedCarts";
import { useTranslation } from "react-i18next";
import { useConfig } from "../../../../providers/config";

const Collections = () => {
  const { t } = useTranslation();
  const config = useConfig();

  return (
    <div className="flex flex-col gap-2 md:h-full">
      <div className="font-bold text-[1.0625rem]">{t("Collections")}</div>
      <div className="flex flex-col gap-2 lg:flex-row lg:h-full">
        <div className="w-full">
          <WishlistCollection />
        </div>
        {config?.isSharedCartEnabled && (
          <div className="w-full">
            <SharedCartsCollection />
          </div>
        )}
      </div>
    </div>
  );
};

export default Collections;
